import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './LegalPage.module.css';
import Seo from './components/Seo';
import Header from './components/Header';
import Footer from './components/Footer';
import { useI18n } from './i18n/LanguageContext';
import { DEFAULT_LOCALE } from './i18n/config';
import { useContent } from './content';
import { ContentBlock, groupBySection } from './content/blocks';

const ROUTES = {
  terms: '/terms-and-services',
  privacy: '/privacy-policy',
};

/**
 * Terms and Privacy render from the same shell — same layout, same block
 * types, only the document differs. `doc` picks which one.
 */
function LegalPage({ doc }) {
  const navigate = useNavigate();
  const { t, path, locale } = useI18n();
  const content = useContent();

  const document = content[doc];
  const sections = groupBySection(document.blocks);

  return (
    <div className={classes.page}>
      <Seo
        title={t(`meta.${doc}.title`)}
        description={t(`meta.${doc}.description`)}
        routePath={ROUTES[doc]}
      />
      <Header />
      <div className={classes.container}>
        <div className={classes.header}>
          <button onClick={() => navigate(path('/'))} className={classes.backBtn}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            {t('legal.back')}
          </button>
          <h1 className={classes.title}>{document.title}</h1>
        </div>

        <div className={classes.content}>
          <p className={classes.effectiveDate}>
            <strong>{document.effectiveLabel}</strong> {document.effectiveDate}
          </p>

          {/* The English original is the version that actually governs. */}
          {locale !== DEFAULT_LOCALE && (
            <p className={classes.translationNotice}>{t('legal.translationNotice')}</p>
          )}

          {sections.map((blocks, i) => (
            <div key={i} className={classes.section}>
              {blocks.map((block, j) => (
                <ContentBlock key={j} block={block} classes={classes} />
              ))}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default LegalPage;
